import React from 'react';
import { FormSection } from '../../common/FormSection';
import { FormInput } from '../../common/FormInput';
import { FormCheckboxGroup } from '../../common/FormCheckboxGroup';
import { BehaviourSupportPlanData } from 'src/models/form-types';

interface AdditionalInfoSectionProps {
  formData: BehaviourSupportPlanData;
  onTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCheckboxChange: (name: string, checked: boolean, category: keyof BehaviourSupportPlanData) => void;
  className?: string;
}

// Define the additional info options
const additionalInfoOptions = [
  {
    id: 'info-medication',
    name: 'Currently taking prescribed medication',
    label: 'Currently taking prescribed medication',
  },
  {
    id: 'info-allied',
    name: 'Receives Allied Health support (e.g., occupational or speech therapy)',
    label: 'Receives Allied Health support (e.g., occupational or speech therapy)',
  },
  {
    id: 'info-external',
    name: 'Receives external support from a psychologist or paediatrician',
    label: 'Receives external support from a psychologist or paediatrician',
  },
  {
    id: 'info-none',
    name: 'None',
    label: 'None',
  },
];

export const AdditionalInfoSection: React.FC<AdditionalInfoSectionProps> = ({ 
  formData, 
  onTextChange, 
  onCheckboxChange, 
  className 
}) => {
  const isNoneSelected = formData.additionalInfo.includes('None');


  // Modified handleCheckboxChange to uncheck 'None' if another is checked
  const handleCheckboxChange = (name: string, checked: boolean) => {
    if (name !== 'None' && checked && isNoneSelected) {
      onCheckboxChange('None', false, 'additionalInfo');
    }
    onCheckboxChange(name, checked, 'additionalInfo');
  };

  return (
    <FormSection title="Additional Information *" className={className}>
      <FormCheckboxGroup
        options={additionalInfoOptions}
        selectedValues={formData.additionalInfo}
        onChange={handleCheckboxChange}
        columns={2}
      />
      
      <FormInput
        id="otherAdditionalInfo"
        name="otherAdditionalInfo"
        label="Other:"
        value={formData.otherAdditionalInfo}
        onChange={onTextChange}
      />
    </FormSection>
  );
};
